<template>
  <div class="pagination-container" :style="{textAlign:placement}" :class="{'pagination-warp': isQueryAll}">
    <!--
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="current"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>-->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="current"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      layout="prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <el-button size="mini" type="primary" @click="handleQueryAll" v-if="isQueryAll">更多</el-button>
    <!-- <Page
      :page-size="pageSize"
      :current.sync="current"
      :total="total"
      :page-size-opts="pageSizes"
      @on-change="handleCurrentChange"
      @on-page-size-change="handleSizeChange"
      size="small"
      show-elevator
      show-sizer
      show-total
    /> -->
  </div>
</template>

<script>
export default {
  name: "pageSize",
  props:{
    placement:{
      type:String,
      default:'left'
    },
    isQueryAll: {
      type:Boolean,
      default: false
    }
  },
  data: () => ({
    current: 1,
    total: 0,
    pageSizes: [5, 10, 20, 30, 50],
    pageSize: 5,
    QueryAll: undefined,
  }),
  methods: {
    handleSizeChange(size) {
      this.pageSize = size;
      this.current = 1;
      this.$emit("pageChange");
    },
    handleCurrentChange(current) {
      this.current = current;
      this.$emit("pageChange");
    },
    handleQueryAll() {
      this.QueryAll = true;
      this.$emit("pageChange");
    },
  }
};
</script>

<style lang="scss">
.pagination-container {
  padding: 20px 0;
  text-align: right;
}
.el-pagination{
  white-space: normal;
  text-align: right;
  & *{
    margin-bottom: 5px;
  }
}
  .pagination-warp{
    display: flex;
    justify-content: flex-end;
  }
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
  background: transparent;
}
.el-pagination button, .el-pagination span:not([class*=suffix]){
  margin-left: 4px;
}
</style>
